import React, { useState } from 'react'
import {  ZendeskInitialData } from '../types/interface'


const initialData: ZendeskInitialData = {
    historyData: [],
    isHistoryLoading: true,
    activeTickets: [],
    updateHistoryData: () => {},
    updateHistoryLoadingStatus: () => {},
    updateActiveTickets: () => {},
}

export const ZendeskContext = React.createContext(initialData)

const ZendeskContextProvider = (props: any) => {

    const [historyData, setHistoryData] = useState(initialData.historyData)
    const [isHistoryLoading, setIsHistoryLoading] = useState(initialData.isHistoryLoading) // progress, success, failed
    const [activeTickets, setActiveTickets] = useState(initialData.activeTickets)

    const updateHistoryLoadingStatus = (status: boolean = initialData.isHistoryLoading) => {
        setIsHistoryLoading(status)
    }

    const updateHistoryData = (historyData: any[] = initialData.historyData) => {
        setHistoryData(historyData)
    }

    const updateActiveTickets = (ticketIdx: number) => {
        let tickets = [...activeTickets]
        let idx = tickets.indexOf(ticketIdx)
        if(idx != -1) {
            tickets.splice(idx, 1)
            setActiveTickets([...tickets])
        } else {
            setActiveTickets([...tickets, ticketIdx])
        }
    }

    const contextValue = {
        historyData: historyData,
        isHistoryLoading: isHistoryLoading,
        activeTickets: activeTickets,
        updateHistoryLoadingStatus: updateHistoryLoadingStatus,
        updateHistoryData: updateHistoryData,
        updateActiveTickets: updateActiveTickets,
    }

    return (
        <ZendeskContext.Provider value={contextValue}>
            {props.children}
        </ZendeskContext.Provider>
    )
}

export default ZendeskContextProvider
